import api from 'app/api';
import store from 'app/store';

export const getEventById = async (id, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'EVENT_DASHBOARD:EVENT_DATA:SET', data: { details: data?.payload, smpId: data?.smp_id || data?.payload?.id, mongoId: data?.payload?._id || id } });

    if (callback) callback(data);
  };

  await api.get(
    `/events/${id}`,
    {
      id: 'get-event-by-id',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const verifyDirectOtp = async (phoneNumber, orderId, otp, successCallback, failureCallback) => {
  await api.post(
    '/user/otp/verify-direct',
    {
      phoneNumber: `91${phoneNumber}`,
      orderId: orderId,
      otp: otp,
    },
    {
      id: 'verify-otp',
      success: {
        callback: successCallback,
      },
      failure: {
        callback: failureCallback,
      },
    },
  );
}

export const sendDirectOtp = async (phoneNumber, orderId, successCallback, failureCallback) => {
  await api.post(
    '/user/otp/send-direct',
    {
      phoneNumber: `91${phoneNumber}`,
      orderId: orderId,
    },
    {
      id: 'send-direct',
      success: {
        callback: successCallback,
      },
      failure: {
        callback: failureCallback,
      },
    },
  );
}

export const updateEvent = async (id, payload, callback) => {
  const successCallback = ({ data }) => {
    if (data?.payload) {
      store.dispatch({ type: 'EVENT_DASHBOARD:EVENT_DATA:SET', data: { details: data?.payload, smpId: data?.smp_id || data?.payload?.id } });
    } else {
      store.dispatch({ type: 'EVENT_DASHBOARD:EVENT_DATA:SET', data: { details: data?.data, smpId: data?.data?.id } });
    }

    if (callback) callback(data);
  };

  await api.put(
    `/events/primary/${id}`,
    payload,
    {
      id: 'save-event',
      success: {
        callback: successCallback,
      },
    },
  );
};

export const getEventDashboard = async (id, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'EVENT_DASHBOARD:DASHBOARD_DATA:SET', data });

    if (callback) callback(data);
  };

  await api.get(
    `/dashboard/${id}`,
    {
      id: 'get-event-dashboard',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        filter: 'yearly',
      },
    },
  );
};

export const getEventAttendees = async (id, params, dispatch, callback) => {
  const successCallback = ({ data, pagination }) => {
    store.dispatch({
      type: dispatch || 'EVENT_DASHBOARD:ATTENDEES_LIST:SET',
      data: {
        attendeesList: data || [],// ).map((attendeeDetails) => attendeeDetails?.details || []),
        pagination: { ...params, ...pagination },
      },
    });


    if (callback) callback(data);
  };

  await api.get(
    `/events/attendees/${id}`,
    {
      id: 'get-event-attendees',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params,
    },
  );
};

export const exportEventAttendees = async (id, params, callback) => {
  const successCallback = (data) => {
    if (callback) callback(data);
  };

  await api.get(
    `/events/attendees/${id}/export`,
    {
      id: 'export-event-attendees',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params,
    },
  );
}

export const checkIn = async (eventId, payload, callback, failureCb) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  const failureCallback = ({ data }) => {
    if (failureCb) failureCb(data);
  };

  await api.post(
    `/events/${eventId}/checkin`,
    payload,
    {
      id: 'checkin-user',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
        message: 'Failed to checkin user!',
        callback: failureCallback,
      },
    },
  );
};

export const getRefundDashboard = async (id, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.get(
    `/refunds/${id}`,
    {
      id: 'get-refund-dashboard',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const cancelEvent = async (smp_id, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };
  await api.delete(
    `/events/cancel/${smp_id}`,
    {
      id: 'cancel-event',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    }
  );
};
